// import addSeconds from "date-fns/addSeconds";
// import isAfter from "date-fns/isAfter";
// import { parseISO } from "date-fns/fp";
import * as moment from "moment";

const ID_TOKEN_KEY = "tokens";

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getTokens = (section, token_type) => {
  const tokens = JSON.parse(
    window.localStorage.getItem(`${section}-${ID_TOKEN_KEY}`)
  );

  if (token_type) {
    if (tokens && tokens[token_type]) {
      return tokens[token_type];
    } else {
      return null;
    }
  }

  return tokens;
};

export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const saveTokens = (section, tokens) => {
  const tokensExpiry = new moment().add(tokens.expires_in, "seconds");

  tokens.tokensExpiry = tokensExpiry;

  window.localStorage.setItem(
    `${section}-${ID_TOKEN_KEY}`,
    JSON.stringify(tokens)
  );
};

export const destroyToken = section => {
  window.localStorage.removeItem(`${section}-${ID_TOKEN_KEY}`);
};

export const isTokenExpired = section => {
  // const now = new Date();
  const tokensExpiry = getTokens(section, "tokensExpiry");

  if (!tokensExpiry) {
    return false;
  }

  let tokenExpiryDate = new moment(tokensExpiry);

  return moment().isAfter(tokenExpiryDate); // isAfter(now, tokenExpiryDate);
};

export default {
  getToken,
  getTokens,
  saveToken,
  saveTokens,
  destroyToken,
  isTokenExpired
};
